import { CanDeactivateFn } from '@angular/router';
import { TestdatenblattFormComponent } from './testdatenblatt-form.component';

export const canDeactivateTestdatenblattForm: CanDeactivateFn<TestdatenblattFormComponent> = (component) => {
  if (component.hasUnsavedChanges()) {
    return component.confirmDeactivate();
  }
  return true;
};
